"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _ = require("./");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var buildRoute = function buildRoute(_ref) {
  var path = _ref.path,
      loader = _ref.loader,
      section = _objectWithoutProperties(_ref, ["path", "loader"]);

  return _react["default"].createElement(_reactRouterDom.Route, {
    key: section.title,
    path: path,
    component: loader(section)
  });
};

var buildRedirect = function buildRedirect(_ref2) {
  var title = _ref2.title,
      path = _ref2.path,
      loader = _ref2.loader,
      sections = _ref2.sections;
  return _react["default"].createElement(_reactRouterDom.Route, {
    key: title,
    path: path,
    render: function render() {
      return _react["default"].createElement(_reactRouterDom.Redirect, {
        to: sections[0].path
      });
    },
    exact: true
  });
};

var buildRoutes = function buildRoutes(sections) {
  return sections.reduce(function (acc, section) {
    return section.sections ? acc.concat(buildRoutes(section.sections)).concat([buildRedirect(section)]) : acc.concat([buildRoute(section)]);
  }, []);
};

var _default = function _default(sections) {
  return buildRoutes(sections).concat([buildRedirect({
    title: 'home',
    path: '/',
    sections: sections
  })]);
};

exports["default"] = _default;